// Mirrors the backend's findEmailPlaceholders (complianceRegister.ts): leftover "[...]" tokens in an
// email draft mean a human has not filled it in yet, so it must not be approved or sent.
export function findEmailPlaceholders(draft) {
  if (!draft) return [];
  const found = new Set();
  for (const text of [draft.subject, draft.bodyPlain, draft.bodyHtml]) {
    if (typeof text !== "string") continue;
    for (const m of text.matchAll(/\[[^[\]\n<>]{1,80}\]/g)) {
      if (/^\[[A-Z]{2,}-\d+\]$/.test(m[0])) continue;
      found.add(m[0]);
    }
  }
  return [...found];
}

/** [{ refId, placeholders }] for every draft in the package that still has placeholders. */
export function emailsWithPlaceholders(pkg) {
  return Object.entries(pkg?.emailsByRefId || {})
    .map(([refId, d]) => ({ refId, placeholders: findEmailPlaceholders(d) }))
    .filter((e) => e.placeholders.length > 0);
}

export const OWNER_NOT_ASSIGNED = "Owner not assigned";
